/* ============
 * Overview Widgets
 * ============
 *
 * This is the pop up modal.
 */
import { mapMutations, mapGetters } from 'vuex';
import userWidgetsService from './../../services/widgets';

export default {
    data() {
        return {
            cardItems: [],
            allWidgets: []
        };
    },

    computed: {
        ...mapGetters([
          'widgets',
          'availableWidgets',
        ]),
    },

    methods: {
        ...mapMutations({
            toggleModal: 'TOGGLE_MODAL',
        }),
        addWidget(widget, index) {
            if(this.widgets.items != 'no_widget' && this.widgets.items.length > 0) this.cardItems = this.readSerialize(this.widgets.items);
            this.cardItems.push({title:widget.title, sub:widget.subtitle, desc:widget.desc, key:widget.key});
            userWidgetsService.updateUserWidgets(this.cardItems).then(() => {
                this.allWidgets[index].disable = true;
            });
        },
        closeModal() {
            this.toggleModal(false);
        },
        readSerialize(value) {
            var newJson = value.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
            newJson = newJson.replace(/'/g, '"');
            return JSON.parse(newJson);
        },
        filterDisable() {
            if (this.$store.getters.widgets.items != 'no_widget' && this.$store.getters.widgets.items.length > 0) {
                let self = this;
                this.readSerialize(this.$store.getters.widgets.items).forEach(function(item) {
                    self.allWidgets.forEach(function(item2) {
                        if(item.key === item2.key) item2.disable = true;
                    });
                });
            }
        },
        initializeWidgets() {
            Promise.all([
                userWidgetsService.fetchAvailableWidgets(),
            ]).then(() => {
                let self = this;
                this.availableWidgets.items.avialableWidgetsData.forEach(function(item, key) {
                    self.allWidgets.push({'title': item.title, 'desc': item.desc, 'subtitle': item.subtitle, 'key': item.key, 'disable': false});
                });
                this.filterDisable();
            });
        },
    },

    created() {
        this.initializeWidgets();
    }

};



// WEBPACK FOOTER //
// ./src/app/components/overviewWidgets/overviewWidgets.js